<template>
  <app-wrapper>
    <transition appear name="fadeout">
      <v-card class="pa-2">
        <v-img class="mt-4" contain>
          <img width="200" height="57" src="../assets/qg-logo_trans-1a.png" />
        </v-img>
        <v-card-title primary-title>
          <div>
            <h6 class="subheading mb-0">Please provide email and password:</h6>
          </div>
        </v-card-title>
        <v-card-text>
          <v-alert outlined type="error" dismissible class="mb-4 mt-0" v-model="showerr">
            {{ errmsg }}
            <!-- <v-btn v-if="resend" color="primary" text small :to="'/resend'">Re-send Confirmation</v-btn> -->
          </v-alert>
          <v-form v-model="valid" ref="form" @keyup.native.enter="valid && onSubmit()">
            <v-text-field
              autocomplete="username"
              label="E-mail"
              v-model="email"
              :rules="[emailrules.required, emailrules.email]"
              required
              clearable
            ></v-text-field>
            <v-text-field
              autocomplete="current-password"
              label="Password"
              v-model="password"
              :rules="passRules"
              :append-icon="hidepw ? 'visibility' : 'visibility_off'"
              @click:append="() => (hidepw = !hidepw)"
              :type="hidepw ? 'password' : 'text'"
              required
            ></v-text-field>
          </v-form>
          <v-btn
            block
            :loading="loading"
            @click.native="onSubmit()"
            :disabled="!valid"
            color="submit"
          >
            Sign In
            <span slot="loader">Connecting...</span>
          </v-btn>
        </v-card-text>
        <v-card-actions class="ml-2 mb-2">
          <!-- <v-btn text small color="accent" :to="'/register'">Register</v-btn> -->
          <v-btn text small :to="'/forgot'">Forgot Password?</v-btn>
          <v-btn text small :to="'/welcome'">First-Time User?</v-btn>
        </v-card-actions>
      </v-card>
    </transition>
    <!-- <app-terms></app-terms> -->
    <v-dialog v-model="isIE11" persistent max-width="390">
      <v-card>
        <v-card-title class="headline">Browser Not Supported</v-card-title>
        <v-card-text>
          The new QGistix portal does not support IE version 11 or earlier, please upgrade to Microsoft Edge
          or another modern browser (Chrome, Firefox, Brave).
          <br />
          <br />To login directly to the old portal, use this link:
          <a
            href="https://www.qgistix.com/Portal.html"
          >https://www.qgistix.com/Portal.html</a>
        </v-card-text>
      </v-card>
    </v-dialog>
  </app-wrapper>
</template>

<script>
import wrapper from "./wrapper";
import terms from "./terms";
import store from "../store";

export default {
  components: {
    "app-wrapper": wrapper,
    "app-terms": terms
  },
  data: function() {
    return {
      isIE11: false,
      callback: false,
      showerr: false,
      resend: false,
      username: "",
      valid: false,
      email: "",
      emailrules: {
        required: value => !!value || "E-mail is required",
        // I find even the best regex for email has bugs so we don't use the original here
        // here's the original complex regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        email: value => {
          const pattern = /^.+\@.+\..+$/; // I use a very basic and simple regex here that will give a good benefit by failing if users input a username here
          return pattern.test(value) || "E-mail must be valid";
        }
      },
      password: "",
      passRules: [
        v => !!v || "Password is required"
        // (v) => !v || v.length >= 8 || 'Password must be at least 8 characters'
      ],
      hidepw: true,
      loader: false,
      loading: false
    };
  },
  computed: {
    errmsg: function() {
      return this.$store.state.auth.errmsg;
    }
  },
  methods: {
    onSubmit() {
      this.loader = "loading";
      const l = this.loader;
      this[l] = !this[l];
      console.log(
        "sign in with: " + this.email + " " + this.password.replace(/./g, "*")
      );
      store.dispatch("signIn", {
        Username: this.email,
        Password: this.password
      });
    },
    getMessage: function() {
      return this.message;
    }
  },
  watch: {
    errmsg() {
      this.loader = "loading";
      const l = this.loader;
      this[l] = !this[l];
      console.log(`watched error message: ${this.errmsg}`);
      if (this.errmsg !== "") {
        if (this.errmsg.startsWith("UserMigration failed with error ")) {
          store.commit("setError", this.errmsg.substr(32));
        }
        this.showerr = true;
      }
      this[l] = false;
      this.loader = null;
    }
  },
  mounted() {
    var ua = window.navigator.userAgent;
    var trident = ua.indexOf("Trident/");
    if (trident > 0) {
      console.log("IE check is true");

      // IE 11 => return version number
      var rv = ua.indexOf("rv:");
      this.isIE11 = parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      return;
    }
    this.isIE11 = false;
  }
};
</script>
<style scoped>
</style>
